<template>
  <div :class="$style.topbar">
    <div>
      <vb-user-menu />
    </div>
  </div>
</template>

<script>
import VbUserMenu from './UserMenu'

export default {
  components: {
    VbUserMenu,
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
